// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__Eb58A","modalBody":"MealsPop_modalBody__tVI13"};